import { PageNotFound } from '@openx/components-core/lib/PageNotFound.tsx';
import { Route, type RouteProps, Routes } from 'react-router';
import { Consent } from '../modules/auth/consent/Consent.tsx';
import { ForgotPassword } from '../modules/auth/forgotPassword/ForgotPassword.tsx';
import { InstanceSelectPage } from '../modules/auth/instanceSelect/InstanceSelectPage.tsx';
import { Login } from '../modules/auth/login/Login.tsx';
import { Logout } from '../modules/auth/logout/Logout.tsx';
import { Main } from '../modules/auth/main/Main.tsx';
import { PostPasswordSetup } from '../modules/auth/postPasswordSetup/PostPasswordSetup.tsx';
import { UserManagement } from '../modules/auth/userManagement/UserManagement.tsx';
import { usePersistAuthorizationDetails } from '../modules/auth/utils/usePersistAuthorizationDetails.ts';

const routes: RouteProps[] = [
  {
    Component: Main,
    path: '/',
  },
  {
    element: <Login />,
    path: '/login',
  },
  {
    element: <ForgotPassword />,
    path: '/forgot-password',
  },
  {
    element: <UserManagement />,
    path: '/user-management',
  },
  {
    element: <Consent />,
    path: '/consent',
  },
  {
    element: <Logout />,
    path: '/logout',
  },
  {
    element: <PostPasswordSetup />,
    path: '/password-setup',
  },
  {
    element: <InstanceSelectPage />,
    path: '/select-instance',
  },
  {
    element: <PageNotFound />,
    path: '*',
  },
];

export const AppRoutes = () => {
  usePersistAuthorizationDetails();

  return (
    <Routes>
      {routes.map((route, i) => (
        <Route key={i} {...route} />
      ))}
    </Routes>
  );
};
